"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
export function SentryUserProvider({
  user,
  children
}: {
  user: {
    id: string;
    email: string;
  } | null;
  children: React.ReactNode;
}) {
  useEffect(() => {
    Sentry.setUser(user);
  }, [user]);
  return children;
}